import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isObject, isString } from 'lodash';
import { FormattedMessage } from 'react-intl';
import noop from 'lodash/noop';

import { isCurrentLanguageRtl } from 'modules/language/selectors/language';

import theme from './FormFieldTooltip.scss';

class FormFieldTooltip extends Component {
  static propTypes = {
    testId: PropTypes.string.isRequired,
    className: PropTypes.string,
    tooltipMessage: PropTypes.object,
    children: PropTypes.node,
    width: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    tooltipPlacement: PropTypes.oneOf([
      'topStart',
      'topEnd',
      'bottomStart',
      'bottomEnd',
    ]),
    oneLine: PropTypes.bool,
    tooltipSize: PropTypes.oneOf(['large', 'medium']),
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    tooltipMessage: null,
    children: null,
    width: 'fit-content',
    tooltipPlacement: 'bottomStart',
    oneLine: false,
    tooltipSize: 'large',
    onOpen: noop,
    onClose: noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      placement: isCurrentLanguageRtl() ? this.flipPlacement(props.tooltipPlacement) : props.tooltipPlacement,
    };
  }

  componentDidMount() {
    this.setState({ offset: this.tooltipRef.offsetHeight });  // eslint-disable-line
  }

  getTooltipPosition = (placement) => {
    const { width } = this.props;

    if (!this.state.offset) return { opacity: 0, width };

    const { offset } = this.state;

    const styles = {
      'bottomStart': {
        right: 'auto',
        left: 0,
        bottom: -offset,
        width,
      },
      'bottomEnd': {
        right: 0,
        left: 'auto',
        bottom: -offset,
        width,
      },
      'topStart': {
        right: 'auto',
        left: '0px',
        top: -offset,
        width,
      },
      'topEnd': {
        right: 0,
        left: 'auto',
        top: -offset,
        width,
      },
    };

    return styles[placement];
  };

  flipPlacement = (placement) => {
    switch (placement) {
      case 'topStart':
        return 'topEnd';
      case 'topEnd':
        return 'topStart';
      case 'bottomStart':
        return 'bottomEnd';
      case 'bottomEnd':
        return 'bottomStart';
      default:
        return placement;
    }
  };

  render() {
    const { testId, className, tooltipMessage, children, tooltipSize } = this.props;
    const { placement } = this.state;

    if (!children && !tooltipMessage) {
      return null;
    }

    return (
      <div
        data-testid={ testId }
        className={ classnames({
          [theme[tooltipSize]]: !!tooltipSize,
          [theme[placement]]: placement,
        }, theme.root, theme.zoomIn, className) }
        style={ this.getTooltipPosition(placement) }
        ref={ elem => { this.tooltipRef = elem; } }
      >
        <Choose>
          <When condition={ tooltipMessage && isString(tooltipMessage) }>
            { tooltipMessage }
          </When>
          <When condition={ tooltipMessage && isObject(tooltipMessage) }>
            <FormattedMessage { ...tooltipMessage } />
          </When>
          <Otherwise>
            { children }
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

export default FormFieldTooltip;
